import { jsxs, jsx } from 'react/jsx-runtime';
import 'react';
import 'styled-components';
import 'luxon';
import 'lodash';
import '../../../charts/ChartKpis/ChartKpi.js';
import '../../../charts/ChartJS.js';
import '../../../charts/Heatmap/Heatmap.js';
import 'randomcolor';
import 'd3';
import '../../../icons/ActivityIcon.js';
import '../../../icons/ArrowDownIcon.js';
import '../../../icons/ArrowDownRightCircleIcon.js';
import '../../../icons/ArrowLeftAlignIcon.js';
import '../../../icons/ArrowLeftIcon.js';
import '../../../icons/ArrowRightAlignIcon.js';
import '../../../icons/ArrowRightIcon.js';
import '../../../icons/ArrowSwitchIcon.js';
import '../../../icons/ArrowUpIcon.js';
import '../../../icons/ArrowUpRightCircleIcon.js';
import '../../../icons/ArrowsAngleExpandIcon.js';
import '../../../icons/BankIcon.js';
import '../../../icons/CheckIcon.js';
import '../../../icons/ChevronDownIcon.js';
import '../../../icons/ChevronRightIcon.js';
import '../../../icons/ChevronUpIcon.js';
import '../../../icons/CopyIcon.js';
import '../../../icons/CrossIcon.js';
import '../../../icons/DaiIcon.js';
import '../../../icons/DangerIcon.js';
import '../../../icons/DownSortIcon.js';
import '../../../icons/ExclamationTriangleIcon.js';
import '../../../icons/ExpandKpiIcon.js';
import '../../../icons/EyeIcon.js';
import '../../../icons/EyeSlashIcon.js';
import '../../../icons/Grid1x2Icon.js';
import '../../../icons/InfoCircleIcon.js';
import '../../../icons/ListIcon.js';
import '../../../icons/LockIcon.js';
import '../../../icons/MediumIcon.js';
import '../../../icons/MoonIcon.js';
import '../../../icons/PiggyBankIcon.js';
import '../../../icons/QuestionMarkCircleIcon.js';
import '../../../icons/ShieldIcon.js';
import '../../../icons/SunIcon.js';
import '../../../icons/UpSortIcon.js';
import '../../../icons/XIcon.js';
import '../../../icons/InfinityIcon.js';
import '../../../icons/ArrowUpRightBoxIcon.js';
import '../../../pictograms/EthPictogram.js';
import '../../../pictograms/EtherScanPictogram.js';
import '../../../pictograms/DebankPictogram.js';
import '../../../pictograms/ZapperPictogram.js';
import '../../../pictograms/DaiPictogram.js';
import '../../../XRay.js';
import '../../../../theme/GlobalStyle.js';
import 'react-helmet-async';
import ThemedComponentWrapper from '../../../../theme/ThemedComponentWrapper.js';
import 'ethereum-blockies-base64';
import '../../../atoms/layout/Stack/Stack.js';
import '../../../atoms/Table/components/Pagination/Pagination.js';
import '../../../atoms/Table/Table.js';
import '../../../atoms/ToggleSwitch.js';
import '@floating-ui/react';
import '../../../atoms/Tooltip/components/TooltipContext.js';
import CurrencyValue from '../../CurrencyValue/CurrencyValue.js';
import TrendComponent from './TrendComponent.js';
import '../KpiCard.js';
import '../../PercentageValue.js';
import '../../Tabs/Tabs.js';
import '../../TrendValue.js';
import '../../Modal/Modal.js';

function KpiCardFooter({ value, trendChange, trendChangePercentage, options, ...rest }) {
    if (!(value || trendChange)) {
        return null;
    }
    return (jsxs(ThemedComponentWrapper, { ...rest, name: "kpiCardFooter", children: [jsx(CurrencyValue, { value: value, options: {
                    currency: 'USD',
                    notation: 'compact',
                    tooltip: false,
                    ...options?.currencyValueOptions
                } }), jsx(TrendComponent, { trendChange: trendChange, trendChangePercentage: trendChangePercentage, options: options })] }));
}

export { KpiCardFooter as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiS3BpQ2FyZEZvb3Rlci5qcyIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvbW9sZWN1bGVzL0twaUNhcmQvY29tcG9uZW50cy9LcGlDYXJkRm9vdGVyLnRzeCJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBDdXJyZW5jeVZhbHVlIH0gZnJvbSAnQG1vbGVjdWxlcyc7XG5pbXBvcnQgeyBUaGVtZWRDb21wb25lbnRXcmFwcGVyIH0gZnJvbSAnQHRoZW1lJztcbmltcG9ydCB7IFRoZW1lZENvbXBvbmVudFdyYXBwZXJQcm9wcyB9IGZyb20gJy4uLy4uLy4uLy4uL3RoZW1lL1RoZW1lZENvbXBvbmVudFdyYXBwZXInO1xuaW1wb3J0IFRyZW5kQ29tcG9uZW50LCB7IFRyZW5kQ29tcG9uZW50T3B0aW9ucyB9IGZyb20gJy4vVHJlbmRDb21wb25lbnQnO1xuXG5leHBvcnQgaW50ZXJmYWNlIEtwaUNhcmRGb290ZXJQcm9wc1xuICBleHRlbmRzIFBhcnRpYWw8VGhlbWVkQ29tcG9uZW50V3JhcHBlclByb3BzPiB7XG4gIHZhbHVlOiBudW1iZXIgfCBudWxsO1xuICB0cmVuZENoYW5nZTogbnVtYmVyIHwgbnVsbDtcbiAgdHJlbmRDaGFuZ2VQZXJjZW50YWdlOiBudW1iZXIgfCBudWxsO1xuICBvcHRpb25zPzogVHJlbmRDb21wb25lbnRPcHRpb25zO1xufVxuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBLcGlDYXJkRm9vdGVyKHtcbiAgdmFsdWUsXG4gIHRyZW5kQ2hhbmdlLFxuICB0cmVuZENoYW5nZVBlcmNlbnRhZ2UsXG4gIG9wdGlvbnMsXG4gIC4uLnJlc3Rcbn06IEtwaUNhcmRGb290ZXJQcm9wcykge1xuICBpZiAoISh2YWx1ZSB8fCB0cmVuZENoYW5nZSkpIHtcbiAgICByZXR1cm4gbnVsbDtcbiAgfVxuXG4gIHJldHVybiAoXG4gICAgPFRoZW1lZENvbXBvbmVudFdyYXBwZXIgey4uLnJlc3R9IG5hbWU9XCJrcGlDYXJkRm9vdGVyXCI+XG4gICAgICA8Q3VycmVuY3lWYWx1ZVxuICAgICAgICB2YWx1ZT17dmFsdWV9XG4gICAgICAgIG9wdGlvbnM9e3tcbiAgICAgICAgICBjdXJyZW5jeTogJ1VTRCcsXG4gICAgICAgICAgbm90YXRpb246ICdjb21wYWN0JyxcbiAgICAgICAgICB0b29sdGlwOiBmYWxzZSxcbiAgICAgICAgICAuLi5vcHRpb25zPy5jdXJyZW5jeVZhbHVlT3B0aW9uc1xuICAgICAgICB9fVxuICAgICAgLz5cblxuICAgICAgPFRyZW5kQ29tcG9uZW50XG4gICAgICAgIHRyZW5kQ2hhbmdlPXt0cmVuZENoYW5nZX1cbiAgICAgICAgdHJlbmRDaGFuZ2VQZXJjZW50YWdlPXt0cmVuZENoYW5nZVBlcmNlbnRhZ2V9XG4gICAgICAgIG9wdGlvbnM9e29wdGlvbnN9XG4gICAgICAvPlxuICAgIDwvVGhlbWVkQ29tcG9uZW50V3JhcHBlcj5cbiAgKTtcbn1cbiJdLCJuYW1lcyI6WyJfanN4cyIsIl9qc3giXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFhYyxTQUFVLGFBQWEsQ0FBQyxFQUNwQyxLQUFLLEVBQ0wsV0FBVyxFQUNYLHFCQUFxQixFQUNyQixPQUFPLEVBQ1AsR0FBRyxJQUFJLEVBQ1ksRUFBQTtBQUNuQixJQUFBLElBQUksRUFBRSxLQUFLLElBQUksV0FBVyxDQUFDLEVBQUU7QUFDM0IsUUFBQSxPQUFPLElBQUk7O0FBR2IsSUFBQSxRQUNFQSxJQUFDLENBQUEsc0JBQXNCLE9BQUssSUFBSSxFQUFFLElBQUksRUFBQyxlQUFlLEVBQ3BELFFBQUEsRUFBQSxDQUFBQyxHQUFBLENBQUMsYUFBYSxFQUNaLEVBQUEsS0FBSyxFQUFFLEtBQUssRUFDWixPQUFPLEVBQUU7QUFDUCxvQkFBQSxRQUFRLEVBQUUsS0FBSztBQUNmLG9CQUFBLFFBQVEsRUFBRSxTQUFTO0FBQ25CLG9CQUFBLE9BQU8sRUFBRSxLQUFLO29CQUNkLEdBQUcsT0FBTyxFQUFFO0FBQ2IsaUJBQUEsRUFBQSxDQUNELEVBRUZBLEdBQUMsQ0FBQSxjQUFjLElBQ2IsV0FBVyxFQUFFLFdBQVcsRUFDeEIscUJBQXFCLEVBQUUscUJBQXFCLEVBQzVDLE9BQU8sRUFBRSxPQUFPLEVBQ2hCLENBQUEsQ0FBQSxFQUFBLENBQ3FCO0FBRTdCOzs7OyJ9
